import "babel-es6-polyfill";
import React, {Component, useState} from 'react';
import './App.scss';
import {
    HashRouter as Router,
    Route,
    Link,
    Switch,
    useHistory
} from "react-router-dom";

import {
    isPC,
    isLandscape
} from "@public/Global";
import * as qs from "qs";
import Index from "@pages/Index";
import Employee from "@pages/Employee";
import EmployeeDetail from "@pages/EmployeeDetail";
import Agent from "@pages/Agent";
import global from "@public/Global"
import AutoScreen from "@components/AutoScreen";
import {ConfigProvider, List, theme,Button} from 'antd';
import locale from 'antd/locale/zh_CN';
import {CloseCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
const { getDesignToken, useToken } = theme;
function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={props => {
                return <route.component {...props} routes={route.routes} routeData={route.routeData||{}} name={route.name}/>
            }}
        />
    );
}
function updatePxValues(inputString, multiplier) {
    return inputString.replace(/(\d+)px/g, (match, p1) => {
        return `${parseInt(p1) * multiplier}rem`;
    });
}
export default ()=>{
    const [n, forceUpdate] = useState();
    const [pan,setPan] = useState(false);
    const handleForceUpdate = () => {
        forceUpdate(n => !n); // 触发组件重新渲染
    };
    global.app={
        forceUpdate:()=>{
            let styles=document.head.getElementsByTagName('style');
            let t=Date.now();
            Array.from(styles).filter(style=>!!style.getAttribute('data-token-hash')).forEach((style)=>{
                let {innerHTML}=style;
                if(innerHTML.match(/(\d+)px/g)){
                    style.innerHTML=updatePxValues(innerHTML,1/16);

                }
            })
            handleForceUpdate();
        }
    }
    return (
        <div  id={`app`} className={`${isPC() ? 'pc' : (isLandscape() ? 'landscape' : 'vertical')} app-doc transition relative`}>
            <ConfigProvider theme={{}} locale={locale}>
                <AutoScreen useAuto={false} pageWidth={1920}>
                    <Router>
                        <Switch>
                            <RouteWithSubRoutes path="/employee/:id" component={EmployeeDetail}/>
                            <RouteWithSubRoutes path="/employee" component={Employee}/>
                            <RouteWithSubRoutes path="/agent" component={Agent}/>
                            <RouteWithSubRoutes path={'/index'} name={`首页`} component={Index}/>
                            <RouteWithSubRoutes path="*" component={Index}/>
                        </Switch>
                    </Router>
                </AutoScreen>
            </ConfigProvider>
        </div>
    )
}


